import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleContent from './components/ArticleContent';
import RelatedArticles from './components/RelatedArticles';
import CTASection from '@/pages/home/components/CTASection';

export default function ArticlePage() {
  return (
    <>
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleContent />
        <RelatedArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}